import { openBlock as t, createElementBlock as r, createElementVNode as e, renderSlot as o } from "vue";
/* empty css                 */
import a from "../../_virtual/_plugin-vue_export-helper.js";
import n from "../../utils/mixins/theme/theme.vue.js";
const d = {
  name: "DsPageHeader",
  mixins: [n],
  provide() {
    return {
      trackingData: { "component-name": this.$options.name }
    };
  },
  props: {
    /**
     * Screen size based on breakpoints
     */
    screen: { type: String, required: !0 }
  }
}, i = { class: "ds-page-header" }, c = { class: "ds-container ds-page-header__container" }, _ = { class: "ds-grid" }, p = { class: "ds-grid__col ds-display-flex" }, m = { class: "ds-page-header__logo" }, l = { class: "ds-page-header__nav" };
function h(s, g, f, v, u, $) {
  return t(), r("section", i, [
    e("div", c, [
      e("div", _, [
        e("div", p, [
          e("div", m, [
            o(s.$slots, "logo", { theme: s.theme })
          ]),
          e("div", l, [
            o(s.$slots, "navigation", { theme: s.theme })
          ])
        ])
      ])
    ])
  ]);
}
const E = /* @__PURE__ */ a(d, [["render", h]]);
export {
  E as default
};
